import moment from 'moment-timezone'
import PropTypes from 'prop-types'

import { CalendarPickerDropdown } from './calendar_picker_dropdown'
import { Navigators } from './navigators'
import { NavigatorWrapper, TitleContainer } from './styles'

export const Title = ({
  isPhone,
  date,
  currentView,
  locale,
  goToDate,
  timezone,
  monthFormat = null,
  monthComponent = 'span'
}) => (
  <TitleContainer>
    <NavigatorWrapper>
      <Navigators
        goToDate={goToDate}
        currentView={currentView}
        currentRangeStart={date}
        timezone={timezone}
      />
      <CalendarPickerDropdown
        date={date}
        goToDate={goToDate}
        isPhone={isPhone}
        locale={locale}
        timezone={timezone}
        currentView={currentView}
        monthFormat={monthFormat}
        monthComponent={monthComponent}
      />
    </NavigatorWrapper>
  </TitleContainer>
)

Title.propTypes = {
  isPhone: PropTypes.bool,
  date: PropTypes.instanceOf(moment),
  currentView: PropTypes.string,
  locale: PropTypes.string,
  goToDate: PropTypes.func,
  timezone: PropTypes.string,
  monthFormat: PropTypes.string,
  monthComponent: PropTypes.elementType
}
